import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseSmlouvaWizardSearch } from '@/modules/ojeta-vozidla/wizard-helpers';

const SmlouvaWizard = lazy(() =>
  import('@/modules/ojeta-vozidla/SmlouvaWizard').then((m) => ({ default: m.SmlouvaWizard })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/smlouvy/wizard',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaWizard />
    </Suspense>
  ),
  validateSearch: parseSmlouvaWizardSearch,
});
